module.exports = __webpack_public_path__ + "img/frittatensuppe.f17cfc30.png";